import { ISection } from '@faire/web-api--source/indigofair/data/ISection';
import { IViewLoggingData } from '@faire/web-api--source/indigofair/data/IViewLoggingData';

export namespace IViewLayout {
  /**
   * Return an instance of IViewLayout with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IViewLayout>): IViewLayout =>
    ({
      content: [],
      ...(partial ?? {}),
    }) as IViewLayout;
}

/**
 * The base of the SD UI framework. The SD UI View represents an area of the screen that clients will render onto.
 * This proto should be the top level direct response of a SDUI endpoint
 */
export interface IViewLayout {
  /**
   * A unique identifier for the generated view instance
   */
  id: string | undefined;
  /**
   * The list of sections that comprise the view
   */
  content: Array<ISection>;
  /**
   * Logging data relating the view and all children.
   * While the proto says this field is optional. It is indeed non-optional, mobile app clients will not render anything
   * if the view level logging data is null
   */
  logging_data: IViewLoggingData | undefined;
  /**
   * Information about how the view should tracked for speed purposes.
   * This field represents the total number of components that are required to considered by the view
   * to be interactable or loaded
   * @deprecated
   */
  number_of_components_required_for_interactivity: number | undefined;
}
